import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { Observable, Subject } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReloadToolService {

  constructor() { }
  private subject = new Subject<any>();
  private subjectUstory = new Subject<any>();
  private subjectSmartChecklist = new Subject<any>();


  triggerTool(entity: any) {
    this.subject.next(entity);
  }

  triggerToolSprint(sTasks: any) {
    this.subjectUstory.next(sTasks);
  }

  triggerSmartChecklist(tool: any) {
    this.subjectSmartChecklist.next(tool);
  }

  getSmartChecklist(): Observable<any> {
    return this.subjectSmartChecklist.asObservable();
  }

  getSprintTasks(): Observable<any> {
    return this.subjectUstory.asObservable();
  }

  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

}
